module.exports = __webpack_public_path__ + "static/media/customDesignExampleSmall2.cc42b6bb.jpg";